require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./services-content-writing-product-descriptions.json") })
        }
      }, "path---services-content-writing-product-descriptions");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---services-content-writing-product-descriptions!./.cache/json/services-content-writing-product-descriptions.json
// module id = 735
// module chunks = 231608221292675